import * as _ from 'underscore';

import { validators as validatorsPlatform } from '../../../_common/platform/ts/validators';
import { validators as appValidators } from '../../../_common/application/ts/validators';

import * as AttrQueryValuesFormat from '../../../_common/platform/ts/AttrQueryValuesFormat';
import { DataQuerySingleValueField } from '../../../_common/application/tsx/DataQuerySingleValueField';
import { getDefaultTitleForAttrQuery, IAttrQueryMultiFieldValue } from './components/AttrQueryMultiField';
import { IAttrQueryValue } from './components/Interfaces';
import { AXIS_LIST, AXIS_UNIQUE_LIST, getVariatedAxisList, isD3chart } from './chartConstants';
import { IValidator } from '../../../_common/platform/ts/ParameterFieldBase';

let _AttrQueryValuesValidators: IValidator[];
let _AttrQueryValueValidators: IValidator[];

export const validators = {
    attrquery_charts: {
        shouldHaveAxis: function (value: IAttrQueryValue) {
            if (appValidators.attrQuery.isDisabled(value)) {
                return;
            }

            if (value.axis == null || value.axis === 'none') {
                return ['Axis should be specified for all Attributes'];
            }

            return;
        },

        evalActualChartType: function (chartType: string, values: IAttrQueryValue[]) {
            var find = _.find(values, (val) => {
                if (val.chartTypeMain != null) {
                    return true;
                }
            });

            let result = chartType;

            if (find != null) {
                result = find.chartTypeMain;
            }

            return result;
        },

        //LL: aggregation for Y axis cannot be "group" - for all Ys
        //             aggregationForYs(['Y','Y_Min','Y_Max','Y_Open','Y_Close','Y_High','Y_Low'])
        aggregationForYs: function (Ys) {
            return function (value: IAttrQueryValue[]) {
                //EVG: Commented because of wrong type.
                // if (appValidators.attrQuery.isDisabled(value)) {
                //     return;
                // }

                let chartTypeMainActual = validators.attrquery_charts.evalActualChartType('', value); // chartTypeM
                const axisListVar = getVariatedAxisList(chartTypeMainActual);

                //LL: 04.08.16: when scatter it is allowed to group by XP (Point Label)
                let isScatter = chartTypeMainActual === 'scatter';

                let err = false;
                let wrongYs = [];
                let aggrGroup = _.each(Ys, (y) => {
                    let findGroup = _.find(value, (obj) => {
                        //LL: 04.08.16: when scatter it is allowed to group by XP (Point Label)
                        if (!(y === 'XP' && isScatter)) {
                            return obj.axis === y && obj.aggregateGroup === 'group';
                        }
                    });
                    if (findGroup != null) {
                        err = true;
                        if (axisListVar[y] != null) {
                            wrongYs.push('"' + axisListVar[y] + '"');
                        } else {
                            wrongYs.push(y);
                        }
                    }
                });

                if (err) {
                    let names = wrongYs.join(', ');
                    return ['Grouping is not allowed for axis ' + names];
                }
            };
        },

        //LL:  "group" for XC is allowed, but only if there are X2 or X3
        //     otherwise there are many Ys for each X, and of different colors
        //     And if apply actual grouping by XC, which is it: Stack or SideBySide
        aggregationForXC: function () {
            return function (value) {
                if (appValidators.attrQuery.isDisabled(value)) {
                    return;
                }

                let find = _.find<any>(value, (obj: any) => {
                    return obj.axis === 'XC' && obj.aggregateGroup === 'group';
                });

                if (find != null) {
                    //let Xs = ['X1', 'X2', 'XP'];  X4s

                    let count = _.countBy<any>(value, (obj) => {
                        if (obj.aggregateGroup === 'group') {
                            return obj.axis;
                        }
                    });

                    let x2 = count['X2'] != null ? count['X2'] : 0;
                    let x3 = count['X3'] != null ? count['X3'] : 0;

                    if (x2 === 0 && x3 === 0) {
                        return [
                            'PointColor "group" Aggregation is allowed only if Stack or SideBySide grouping exists'
                        ];
                    }
                }
            };
        },

        //LL: when scatter, it is allowed to group only by one of: by X1, X2, or XP
        aggregationForScatter: function () {
            return function (value: IAttrQueryValue[]) {
                //EVG: Commented because of wrong type.
                // if (appValidators.attrQuery.isDisabled(value)) {
                //     return;
                // }

                let chartTypeMainActual = validators.attrquery_charts.evalActualChartType('', value);

                if (chartTypeMainActual !== 'scatter') {
                    return;
                }

                //let Xs = ['X1', 'X2', 'XP'];  X4s

                let count = _.countBy(value, (obj) => {
                    if (obj.aggregateGroup === 'group') {
                        return obj.axis;
                    }
                });

                let x1 = count['X1'] != null ? count['X1'] : 0;
                let x4s = count['X4s'] != null ? count['X4s'] : 0;
                let xP = count['XP'] != null ? count['XP'] : 0;

                if (x1 + x4s + xP > 1) {
                    return ['Scatter chart can have only one Group Aggregation'];
                }
            };
        },

        //LL: aggregation for Z_Size axis cannot be "group"
        aggregationForZSize: function (value: IAttrQueryValue[]) {
            //EVG: Commented because of wrong type.
            // if (appValidators.attrQuery.isDisabled(value)) {
            //     return;
            // }

            let find = _.find(value, (obj) => {
                return obj.axis === 'Z_Size' && obj.aggregateGroup === 'group';
            });

            if (find != null) {
                return ['Grouping is not allowed for axis Z-Size'];
            }
        },

        //LL: 03.12.14: X3-NoGroup => Y3, use _.map() to x3 -> Y3
        modifyValues: function (values: IAttrQueryValue[]) {
            var valueModified = _.map(values, (obj) => {
                if (obj.axis === 'X3' && obj.aggregateGroup != 'group') {
                    return { axis: 'Y3' };
                } else {
                    return obj;
                }
            });
            return valueModified;
        },

        //LL: 27.07.20: Leo believes now that X1 always may be like for scatter,i.e. none,group or numeric
        //     He tells that anyway we can use Expression with "count" as Argument, so why not allow always
        //     In my opinion, it was AQL restriction, so if see wants, why not ...
        //LL: Do not know about X2,X3 - but let's wait :)
        //LL: 27.07.20: so add new param: allowNumericForX1

        //LL: all 'none' or all 'group';  for scatter: X1 may be just "numeric" (numeric type or count aggreg)
        aggregationForXs: function (Xs, AxisList, chartType, chartTypeFunc, isAttributeNumericFunc, allowNumericForX1) {
            return function (value: IAttrQueryValue[]) {
                //EVG: Commented because of wrong type.
                // if (appValidators.attrQuery.isDisabled(value)) {
                //     return;
                // }

                //LL: add chartType, chartTypeFunc - different for "Scatter", X1 may be "count"
                let chartTypeM = chartType;
                if (chartTypeFunc != null) {
                    if (chartTypeM == null) {
                        chartTypeM = chartTypeFunc();
                    }
                }
                //LL: this will be actual ChartType:
                let chartTypeMainActual = validators.attrquery_charts.evalActualChartType(chartTypeM, value);
                let isScatter = chartTypeMainActual === 'scatter';

                let hasNone = false;
                let hasGroup = false;
                let hasOther = false;
                let foundXs = []; // for err message
                let valueModified = validators.attrquery_charts.modifyValues(value);
                let aggrGroup = _.each(Xs, (x) => {
                    let find0 = _.find(valueModified, (obj) => {
                        return obj.axis === x && (obj.aggregateGroup == null || obj.aggregateGroup === 'none');
                    });
                    if (find0 != null) hasNone = true;

                    let findGroup = _.find(valueModified, (obj) => {
                        return obj.axis === x && obj.aggregateGroup === 'group';
                    });
                    if (findGroup != null) hasGroup = true;

                    let hasCountX1 = false;

                    if ((isScatter && x === 'X1') || (allowNumericForX1 === true && x === 'X1')) {
                        let findCount = _.find(valueModified, (obj) => {
                            if (obj.axis === x) {
                                let isNumeric;
                                if (isScatter) {
                                    if (isAttributeNumericFunc != null) {
                                        isNumeric = isAttributeNumericFunc(obj);
                                    } else {
                                        isNumeric = AttrQueryValuesFormat.isCountAggregate(obj);
                                    }
                                } else {
                                    //LL: seems that also can be Date or String, etc
                                    isNumeric = true;
                                }
                                return isNumeric;
                            }
                        });

                        if (findCount != null) {
                            hasCountX1 = true;
                        }
                    }

                    let findX = _.find(valueModified, (obj) => {
                        return obj.axis === x;
                    });
                    if (findX != null) {
                        if (AxisList[x] != null) foundXs.push('"' + AxisList[x] + '"');
                        else foundXs.push(x);
                        if (find0 == null && findGroup == null) {
                            if (hasCountX1 !== true) {
                                hasOther = true;
                            }
                        }
                    }
                });

                if (foundXs.length > 0) {
                    if (hasOther || (hasNone && hasGroup)) {
                        const allAxisText = foundXs.length > 1 ? 'All axis: ' : '';
                        const nameX1 = AxisList['X1'];
                        const groupForArgumentText =
                            allowNumericForX1 === true
                                ? 'must be numeric for ' + nameX1
                                : 'must be numeric for ' + nameX1 + ' when scatter';
                        let names = foundXs.join(', ');
                        return [
                            allAxisText + names + ' must have "group" aggregation or "none" or ' + groupForArgumentText
                        ];
                    }
                }
            };
        },

        //LL: only one Y when X2 or X3 are set:  call onlyOneY_withAxis(['X2', 'X3'])
        onlyOneY_withAxis: function (vals) {
            return function (value: IAttrQueryValue[]) {
                //EVG: Commented because of wrong type.
                // if (appValidators.attrQuery.isDisabled(value)) {
                //     return;
                // }

                let valueModified = validators.attrquery_charts.modifyValues(value);

                let count = _.countBy<any>(valueModified, (obj) => {
                    return obj.axis || 'none';
                });

                if (count['Y'] != null && count['Y'] > 1) {
                    let find = _.find<any>(vals, (val) => {
                        return count[val] != null;
                    });

                    if (find != null) {
                        let nn = _.map<any, any>(vals, (a) => {
                            if (AXIS_LIST[a] != null) return '"' + AXIS_LIST[a] + '"';
                            else return a;
                        });
                        let names = nn.join(', ');
                        return ['Axis "Values(Y)" can be set only once when any of ' + names + ' is defined'];
                    }
                }
            };
        },

        //LL: X3-NoGroup = Y3, use _.map() to x3 -> Y3
        //LL: no Y3 when X2 or X3 are set:  call noY3_withAxis(['X2', 'X3'])
        noY3_withAxis: function (vals) {
            return function (value: IAttrQueryValue[]) {
                //EVG: Commented because of wrong type.
                // if (appValidators.attrQuery.isDisabled(value)) {
                //     return;
                // }

                let valueModified = validators.attrquery_charts.modifyValues(value);

                let count = _.countBy(valueModified, (obj) => {
                    return obj.axis || 'none';
                });

                if (count['Y3'] != null) {
                    let find = _.find(vals, (val) => {
                        return count[val] != null;
                    });

                    if (find != null) {
                        let nn = _.map(vals, (a) => {
                            if (AXIS_LIST[a] != null) {
                                return '"' + AXIS_LIST[a] + '"';
                            } else {
                                return a;
                            }
                        });
                        let names = nn.join(', ');
                        return [
                            'Axis "Stacked" without Grouping is prohibited when any of "grouping" rows (' +
                                names +
                                ') is defined'
                        ];
                    }
                }
            };
        },

        //LL: either all Y, or only one Y and other Y3. Also let it be valid: all Y3 (will be wrong, because Y must exist)
        axis_Y_Y3: function (value: IAttrQueryValue[]) {
            //EVG: Commented because of wrong type.
            // if (appValidators.attrQuery.isDisabled(value)) {
            //     return;
            // }

            let valueModified = validators.attrquery_charts.modifyValues(value);
            let count = _.countBy(valueModified, (obj) => {
                return obj.axis || 'none';
            });
            let err = false;

            if (count['Y'] != null && count['Y3'] != null) {
                err = count['Y'] > 1;
            }

            if (err) {
                return ['Allowed Ys: either all Values, or only one Values and others Stacked'];
            }
        },

        axisUnique: function (value: IAttrQueryValue[]) {
            //EVG: Commented because of wrong type.
            // if (appValidators.attrQuery.isDisabled(value)) {
            //     return;
            // }

            const chartTypeMainActual = validators.attrquery_charts.evalActualChartType('', value);
            const axisListVar = getVariatedAxisList(chartTypeMainActual);
            const valueModified = validators.attrquery_charts.modifyValues(value);
            const count = _.countBy(valueModified, (obj) => {
                return obj.axis || 'none';
            });

            let find = _.find(AXIS_UNIQUE_LIST, (val) => {
                if (count[val] == null) {
                    return false;
                }

                return count[val] > 1;
            });

            if (find != null) {
                if (axisListVar[find] != null) {
                    find = '"' + axisListVar[find] + '"';
                }

                return ['Axis ' + find + ' can be set only once'];
            }
        },

        axisRequire: function (vals, AxisList) {
            return function (value) {
                if (appValidators.attrQuery.isDisabled(value)) {
                    return;
                }

                let count = _.countBy<any>(value, (obj) => {
                    return obj.axis || 'none';
                });

                let find = _.find<any>(vals, (val) => {
                    if (count[val] == null) {
                        return true;
                    }
                    return count[val] === 0;
                });

                if (find != null) {
                    if (AxisList[find] != null) {
                        find = '"' + AxisList[find] + '"';
                    }
                    return [find + ' must be specified'];
                }
            };
        },

        axisRequireOneOf: function (vals, typeName?: string) {
            return function (value: IAttrQueryValue[]) {
                //EVG: Commented because of wrong type.
                // if (appValidators.attrQuery.isDisabled(value)) {
                //     return;
                // }

                let count = _.countBy(value, (obj) => {
                    return obj.axis ?? 'none';
                });

                //LL: find any of vals:
                let find = _.find(vals, (val) => {
                    if (count[val] != null && count[val] > 0) {
                        return true;
                    }
                });

                if (find == null) {
                    return [`One of ${typeName ?? 'Value'} axis must be specified`];
                }
            };
        },

        // axisRequireOneOf1: function (value: IAttrQueryValue) {
        //     return this.axisRequireOneOf(['X1', 'X1d'], '"Argument"')(value);
        // },

        // axisRequireOneOf2: function (value: IAttrQueryValue) {
        //     return this.axisRequireOneOf(['Y', 'Ya', 'Yb', 'Y_Min', 'Y_Max', 'Y_Open', 'Y_Close', 'Y_High', 'Y_Low'])(
        //         value
        //     );
        // },

        //LL: for ['Y_Min','Y_Max'] and ['Y_Open','Y_Close','Y_High','Y_Low']
        axisEqualNumber: function (vals) {
            return function (value: IAttrQueryValue[]) {
                //EVG: Commented because of wrong type.
                // if (appValidators.attrQuery.isDisabled(value)) {
                //     return;
                // }

                let count = _.countBy(value, (obj) => {
                    return obj.axis || 'none';
                });

                let has = false;
                let hasUndef = false;
                let num = _.map(vals, (val) => {
                    if (count[val] != null) has = true;
                    if (count[val] == null) hasUndef = true;
                    return count[val];
                });

                if (has) {
                    let err = false;

                    if (hasUndef) {
                        err = true;
                    } else {
                        let min = _.min(num);
                        let max = _.max(num);
                        err = min != max;
                    }

                    if (err) {
                        let nn = _.map(vals, (a) => {
                            if (AXIS_LIST[a] != null) {
                                return '"' + AXIS_LIST[a] + '"';
                            } else {
                                return a;
                            }
                        });
                        let names = nn.join(', ');

                        return [`The number of axis ${names} should be equal`];
                    }
                }
            };
        },

        axisRequireZSizeForBubble_2: function (chartType, chartTypeFunc) {
            return function (value: IAttrQueryValue[]) {
                //EVG: Commented because of wrong type.
                // if (appValidators.attrQuery.isDisabled(value)) {
                //     return;
                // }

                let chartTypeM = chartType;

                if (chartTypeM == null) {
                    chartTypeM = chartTypeFunc();
                }

                const chartTypeMainActual = validators.attrquery_charts.evalActualChartType(chartTypeM, value);

                if (chartTypeMainActual === 'bubble') {
                    let find = _.find(value, (obj) => {
                        return obj.axis === 'Z_Size';
                    });

                    if (find == null) {
                        return ['Axis "Size for bubble" must be specified for "bubble" chart'];
                    }
                }
            };
        },

        prohibitColorForGroupedD3: function (value: IAttrQueryValue[]) {
            //EVG: Commented because of wrong type.
            // if (appValidators.attrQuery.isDisabled(value)) {
            //     return;
            // }

            let valueModified = validators.attrquery_charts.modifyValues(value);
            let count = _.countBy(valueModified, (obj) => {
                return obj.axis || 'none';
            });
            //let err = false;
            if (count['X5'] != null && count['XC'] != null) {
                return ['Color customization is prohibited when D3-chart uses grouping'];
            }
        }
    },

    attrquery_multi_charts: {
        //LL: for attrQueryMulti - without main (single) AQ
        notEmpty: function (value: IAttrQueryMultiFieldValue) {
            if (value.enabled !== true) {
                if (value != null && value.attrQueries != null && value.attrQueries.length === 0) {
                    return ['At least one Data Descriptor should be specified'];
                } else {
                    return;
                }
            }

            if (value == null || value.attrQueries == null || value.attrQueries.length === 0) {
                return ['At least one Data Descriptor should be specified'];
            }
        },

        //LL: for attrQueryMulti - without main (single) AQ
        axisArgumentsRequireUnique: function (value) {
            if (value.enabled != true) {
                return;
            }

            let args = 0;

            _.chain(value.attrQueries)
                .pluck('dataDescriptor')
                .each((DD) => {
                    let count = _.countBy(DD, (obj) => {
                        return obj.axis || 'none';
                    });
                    if (count['X1'] != null) {
                        args += count['X1'];
                    }
                });
            if (args === 0) {
                return ['Argument Axis must be specified'];
            }
            if (args > 1) {
                return ['Argument Axis can be set only once'];
            }
        },

        //LL: for attrQueryMulti_2 - with main (single) AQ.  Main AQ remains visible, Arg only in main AQ
        axisArgumentsProhibited: function (value) {
            if (value.enabled != true) {
                return;
            }

            let args = 0;

            _.chain(value.attrQueries)
                .pluck('dataDescriptor')
                .each((DD) => {
                    let count = _.countBy(DD, (obj) => {
                        return obj.axis || 'none';
                    });
                    if (count['X1'] != null) {
                        args += count['X1'];
                    }
                });
            if (args !== 0) {
                return ['Argument Axis must NOT be specified'];
            }
        },

        mainValueAxisUndefined: function (value: IAttrQueryMultiFieldValue) {
            if (value.enabled != true) {
                return;
            }

            let Ys = 0;

            _.chain(value.attrQueries)
                .pluck('parameters')
                .each((PP) => {
                    if (
                        PP.secondaryValueAxis == null ||
                        PP.secondaryValueAxis === '' ||
                        PP.secondaryValueAxis === 'Y'
                    ) {
                        Ys++;
                    }
                });

            if (Ys === 0) {
                return ['Main Value Axis must be used at least for one Data Query'];
            }
        },

        pieOnlyOne: function (value: IAttrQueryMultiFieldValue) {
            if (value.enabled != true) {
                return;
            }

            let pie = 0;
            let not_pie = 0;
            _.chain(value.attrQueries)
                .pluck('parameters')
                .each((PP) => {
                    if (PP.chartType === 'pie' || PP.chartType === 'doughnut') {
                        pie++;
                    } else {
                        not_pie++;
                    }
                });
            if (pie === 0) {
                return;
            }
            //  for pie > 0 :
            if (not_pie > 0) {
                return ['Cannot mix Pie/Doughnut chart type with XY chart type'];
            }
            if (pie > 1) {
                return ['Pie/Doughnut chart type can be only one'];
            }
        },

        allChildrenValid: function (value: IAttrQueryMultiFieldValue) {
            if (value.enabled != true) {
                return;
            }

            if (value.attrQueries == null) {
                return;
            }

            //LL:  pluck('valid')  returns nulls if no 'valid' field
            let find = _.chain(value.attrQueries)
                .pluck('valid')
                .find((v) => {
                    if (v != null) {
                        return v.valid !== true;
                    } else {
                        return false;
                    }
                })
                .value();

            //LL: 23.09.16: for EU - validFilter
            //LL:  pluck('validFilter')  returns nulls if no 'validFilter' field
            if (find == null) {
                find = _.chain(value.attrQueries)
                    .pluck('validFilter')
                    .find((v) => {
                        if (v != null) {
                            return v.valid !== true;
                        } else {
                            return false;
                        }
                    })
                    .value();
            }

            if (find != null) {
                return ['Some Data Queries are not valid'];
            }
        },

        titlesDifferent: function (value: IAttrQueryMultiFieldValue) {
            if (value.enabled != true) {
                return;
            }

            let count = _.countBy(value.attrQueries, (obj, index) => {
                let parameters = obj.parameters;
                let title = parameters.title;

                if (title != null) {
                    title = $.trim(title);
                }

                if (title == null || title === '') {
                    title = getDefaultTitleForAttrQuery(index);
                }

                return title;
            });
            let find = _.find(count, (num) => {
                return num > 1;
            });
            if (find != null) {
                return ['Data Query Titles should be different'];
            }
        },

        d3OnlyOne: function (value: IAttrQueryMultiFieldValue) {
            if (value.enabled != true) {
                return;
            }

            let d3 = 0;
            let not_d3 = 0;
            _.chain(value.attrQueries)
                .pluck('parameters')
                .each((PP) => {
                    if (isD3chart(PP.chartType)) {
                        d3++;
                    } else {
                        not_d3++;
                    }
                });
            if (d3 === 0) {
                return;
            }

            if (not_d3 > 0) {
                return ['Cannot mix d3-chart type with XY chart type'];
            }
            if (d3 > 1) {
                return ['d3-chart type can be only one'];
            }
        },

        //LL: prohibit DateTime
        dataTypeForC2F: function (check_dataTypeForC2F_Func: (value: IAttrQueryMultiFieldValue) => boolean) {
            return function (value: IAttrQueryMultiFieldValue) {
                if (value.enabled != true) {
                    return;
                }

                let res = true;

                if (check_dataTypeForC2F_Func != null) {
                    res = check_dataTypeForC2F_Func(value);
                }

                if (res) {
                    return;
                } else {
                    return [
                        '"Click to Filter" cannot be of type DateTime' // or simply "wrong type" ?
                    ];
                }
            };
        },

        //LL: same types
        dataTypeForClickToFilterSurrogate: function (
            check_dataTypeForClickToFilterSurrogate_Func: (value: IAttrQueryMultiFieldValue) => any[]
        ) {
            return function (value: IAttrQueryMultiFieldValue) {
                if (value.enabled != true) {
                    return;
                }

                let res = [];

                if (check_dataTypeForClickToFilterSurrogate_Func != null) {
                    res = check_dataTypeForClickToFilterSurrogate_Func(value);
                }
                //LL: res array of { attributeType: aType, clickToFilterAttributeType: at, attribute: attr.attribute, clickToFilterAttribute: attr.clickToFilterAttribute }

                if (res.length === 0) {
                    return;
                } else {
                    let errList = _.map(res, (a) => {
                        return (
                            'Attribute ' +
                            a.attribute +
                            ' is of type ' +
                            a.attributeType +
                            ', clickToFilterAttribute ' +
                            a.clickToFilterAttribute +
                            ' is of type ' +
                            a.clickToFilterAttributeType
                        );
                    });
                    errList = _.union(
                        ['Argument type and its "Click-to-filter" Argument type must be compatible'],
                        errList
                    );
                    //return errList;  //LL: too many will return error, so don't
                    console.log('Validator attrquery_multi_charts.dataTypeForClickToFilterSurrogate returns error:');
                    console.log(errList);
                    return;
                }
            };
        },

        shouldHaveAxis: function (value: IAttrQueryMultiFieldValue) {
            const find = value.attrQueries?.find((attrQuery) => {
                return attrQuery.dataDescriptor?.find(
                    (data) => validators.attrquery_charts.shouldHaveAxis(data) != null
                );
            });

            if (find != null) {
                return ['Axis should be specified for all Attributes'];
            }
        },

        validateAttrQueries: function (value: IAttrQueryMultiFieldValue) {
            if (!value.enabled) {
                return;
            }

            const result: string[] = [];

            value.attrQueries?.forEach((attrQuery) => {
                const attrQueryValues = attrQuery.dataDescriptor;

                if (attrQueryValues != null) {
                    const error = validators.attrquery_multi_charts.validateAttrQueryValues(attrQueryValues);

                    if (error != null) {
                        result.push(...error);
                    }
                }
            });

            return result.length > 0 ? result : undefined;
        },

        validateAttrQueryValues: function (values: IAttrQueryValue[]) {
            const result: string[] = [];

            let error: string[];

            const attrQueiryValuesValidators = validators.getAttrQueryValuesValidators();
            const attrQueiryValueValidators = validators.getAttrQueryValueValidators();

            attrQueiryValuesValidators.forEach((validator) => {
                error = validator(values);

                if (error != null) {
                    result.push(...error);
                }
            });

            values.forEach((value) => {
                attrQueiryValueValidators.forEach((validator) => {
                    error = validator(value);

                    if (error != null) {
                        result.push(...error);
                    }
                });
            });

            return result.length > 0 ? result : undefined;
        }
    },

    getAttrQueryValuesValidators: function () {
        if (_AttrQueryValuesValidators == null) {
            _AttrQueryValuesValidators = [
                validators.attrquery_charts.axisUnique,
                validators.attrquery_charts.axisRequireOneOf(['X1', 'X1d'], 'Argument'),
                validators.attrquery_charts.axisRequireOneOf([
                    'Y',
                    'Ya',
                    'Yb',
                    'Y_Min',
                    'Y_Max',
                    'Y_Open',
                    'Y_Close',
                    'Y_High',
                    'Y_Low'
                ]),
                validators.attrquery_charts.axisEqualNumber(['Y_Min', 'Y_Max']),
                validators.attrquery_charts.axisEqualNumber(['Y_Open', 'Y_Close', 'Y_High', 'Y_Low']),
                validators.attrquery_charts.onlyOneY_withAxis(['X2', 'X4', 'X4a', 'X4s', 'X5', 'X3']),
                //LL: Leo asks to have case when Ys > 1, stacked (Y + Y3), argCount = 2:
                //LL: prohibit only for X3 ( = "Stacked" with "group"),
                // allow for "Side-by-side", "Separate Lines", "Separate Areas"
                validators.attrquery_charts.noY3_withAxis(['X3']),
                validators.attrquery_charts.axis_Y_Y3,
                validators.attrquery_charts.prohibitColorForGroupedD3,
                //LL: when scatter it is allowed to group only by one of: by X1, X2, or XP:
                validators.attrquery_charts.aggregationForScatter(),
                validators.attrquery_charts.aggregationForYs(
                    [
                        'Y',
                        'Ya',
                        'Yb',
                        'Y_Min',
                        'Y_Max',
                        'Y_Open',
                        'Y_Close',
                        'Y_High',
                        'Y_Low',
                        'StackP'
                        //'C2F'
                    ] // 'T' 'A' 'XC', 'XL', 'XP',
                ),
                validators.attrquery_charts.aggregationForZSize
            ];
        }

        return _AttrQueryValuesValidators;
    },

    getAttrQueryValueValidators: function () {
        if (_AttrQueryValueValidators == null) {
            _AttrQueryValueValidators = [validators.attrquery_charts.shouldHaveAxis];
        }

        return _AttrQueryValueValidators;
    },

    chartParams: {
        axis_label_currency: function (value) {
            if (value.labelFormat === 'currency') {
                let currency = value.labelCurrency;

                if (currency != null) {
                    let ret = validatorsPlatform.string.currency3symbols(currency);

                    if (ret != null) {
                        // it is array
                        if (ret.length > 0) {
                            ret[0] = '"Label Currency" is wrong: ' + ret[0];
                        }
                        return ret;
                    }
                }
            }
        },

        axisConstantLines_shouldHaveValues: function (value) {
            let find = _.find<any>(value, (obj) => {
                if (obj.fromDataSource === true) {
                    // new
                    return !DataQuerySingleValueField.validateQuery(obj.dataQuery);
                } else {
                    return obj.value == null || $.trim(obj.value) === '';
                }
            });

            if (find != null) {
                return ['Non-blank Value should be specified for all Constant Lines'];
            }
        },

        axisConstantLines_wrongDataSourceValue: function (value) {
            let find = _.find<any>(value, (obj) => {
                if (obj.fromDataSource === true) {
                    return !DataQuerySingleValueField.validateQuery_AllowNull(obj.dataQuery);
                }
            });

            if (find != null) {
                return ['Correct Data Source Value or Null should be specified for all Constant Lines'];
            }
        },

        axisStrips_shouldHaveValues: function (value) {
            let find = _.find<any>(value, (obj) => {
                let forStart = false;
                if (obj.fromDataSourceStart === true) {
                    // new
                    forStart = !DataQuerySingleValueField.validateQuery(obj.dataQueryStart);
                } else {
                    forStart = obj.startValue == null || $.trim(obj.startValue) === '';
                }

                let forEnd = false;
                if (obj.fromDataSourceEnd === true) {
                    // new
                    forEnd = !DataQuerySingleValueField.validateQuery(obj.dataQueryEnd);
                } else {
                    forEnd = obj.endValue == null || $.trim(obj.endValue) === '';
                }

                return forStart || forEnd;
            });

            if (find != null) {
                return ['Non-blank StartValue and EndValue should be specified for all Strips'];
            }
        },

        axisStrips_wrongDataSourceValue: function (value) {
            let find = _.find<any>(value, (obj) => {
                let forStart = false;
                if (obj.fromDataSourceStart === true) {
                    forStart = !DataQuerySingleValueField.validateQuery_AllowNull(obj.dataQueryStart);
                }

                let forEnd = false;
                if (obj.fromDataSourceEnd === true) {
                    forEnd = !DataQuerySingleValueField.validateQuery_AllowNull(obj.dataQueryEnd);
                }

                return forStart || forEnd;
            });

            if (find != null) {
                return ['Correct Data Source StartValue and EndValue or Null should be specified for all Strips'];
            }
        },

        axisBreaks_shouldHaveValues: function (value) {
            let find = _.find<any>(value, (obj) => {
                return (
                    obj.startValue == null ||
                    $.trim(obj.startValue) === '' ||
                    obj.endValue == null ||
                    $.trim(obj.endValue) === ''
                );
            });

            if (find != null) {
                return ['Non-blank StartValue and EndValue should be specified for all Breaks'];
            }
        },

        secondaryValueAxis_shouldHaveNames: function (value) {
            let find = _.find<any>(value, (obj) => {
                return obj.name == null || $.trim(obj.name) === '';
            });

            if (find != null) {
                return ['Non-blank Name should be specified for all Secondary ValueAxis'];
            }
        },

        secondaryValueAxis_namesUnique: function (value) {
            let count = _.countBy<any>(value, (obj) => {
                let name = obj.name;
                if (name != null) {
                    name = $.trim(name);
                } else {
                    name = ' ';
                }
                return name;
            });
            let find = _.find<any>(count, (num) => {
                return num > 1;
            });
            if (find != null) {
                return ['Names should be different for all Secondary ValueAxis'];
            }
        },

        //LL: for customStyles, colorMappingForNumeric:
        customStyles_shouldHaveNames: function (value) {
            let find = _.find<any>(value, (obj) => {
                return obj.name == null || $.trim(obj.name) === '';
            });

            if (find != null) {
                return ['Non-blank Name should be specified for all items'];
            }
        },

        //LL: for customStyles, colorMappingForNumeric:
        customStyles_namesUnique: function (value) {
            let count = _.countBy<any>(value, (obj) => {
                let name = obj.name;
                if (name != null) {
                    name = $.trim(name);
                } else {
                    name = ' ';
                }
                return name;
            });
            let find = _.find<any>(count, (num) => {
                return num > 1;
            });
            if (find != null) {
                return ['Names should be different for all items'];
            }
        },

        customStyles_Opacity: function (value) {
            let find = _.find<any>(value, (obj: any) => {
                return obj.opacity != null && (obj.opacity > 1 || obj.opacity < 0);
            });

            if (find != null) {
                return ['"Opacity" must be in interval [0,1]'];
            }
        },

        colorMappingForNumeric_MinMax: function (value) {
            let find = _.find<any>(value, (obj: any) => {
                return obj.scaleMin != null && obj.scaleMax != null && obj.scaleMin > obj.scaleMax;
            });

            if (find != null) {
                return ['Some Scale Values are wrong: "Min" must be <= "Max"'];
            }
        },

        formatConfig_objectsUnique: function (value) {
            let count = _.countBy<any>(value, (obj) => {
                return obj.object;
            });
            let find = _.find<any>(count, (num) => {
                return num > 1;
            });
            if (find != null) {
                return ['Objects should be different'];
            }
        },

        percent_Max: function (value) {
            let find = _.find<any>(value, (obj: any) => {
                return obj.scaleMin != null && obj.scaleMax != null && obj.scaleMin > obj.scaleMax;
            });

            if (value > 100) {
                return ['Percent Value must be <= 100'];
            }
        }
    }
};
